import React from 'react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-16 px-4 md:px-8 bg-gradient-to-br from-green-50 to-emerald-50" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-123">
          <div className="text-6xl mb-6" data-id="element-124">🛡️</div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2E7D32] mb-6" data-id="element-125">
            Garantía de 14 Días
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-126">
            Si por cualquier motivo no quedás satisfecho con el contenido, solo
            contactanos y te reembolsamos el 100% de tu compra.
          </p>
          <p className="text-xl font-semibold text-[#1A1A1A] mt-4" data-id="element-127">
            Sin preguntas. Sin vueltas. Tu confianza vale más que cualquier
            venta.
          </p>
        </motion.div>
      </div>
    </section>;
}